import { INITIAL_STATE, viewReducer } from './viewReducer'
import React, { FC, ReactNode, useReducer } from 'react'
import ViewContext from './Context'

const ViewProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(viewReducer, INITIAL_STATE)

  return (
    <ViewContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ViewContext.Provider>
  )
}

export default ViewProvider